module.exports = __webpack_public_path__ + "images/emoji/kimono.e8916cafcc0f8b044e7b.png";